import React from "react";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import useGeocode from "hooks/useGetLocationName";
import styles from "./LifeTrackingWindowInfo.module.css";

function LifeTrackingWindowInfo({ selectedTripDetails }) {
    const tripStatus = selectedTripDetails?.activeTripDetails?.attributes?.status;
    const { placeName } = useGeocode(selectedTripDetails?.loc?.lat, selectedTripDetails?.loc?.lon);

    return (
        <div className={styles.LifeTrackingWindowInfoContainer}>
            <div className={styles.header}>
                <div className={`${styles.status} ${styles[tripStatus]}`}>{tripStatus}</div>
                <div className={styles.tripInfo}>
                    <span
                        className={`${styles.callStatus} ${
                            selectedTripDetails?.connection
                                ? styles[selectedTripDetails?.connection]
                                : styles.unknown
                        }`}
                    >
                        {selectedTripDetails?.connection
                            ? selectedTripDetails?.connection
                            : "unknown"}
                    </span>
                    <div className={styles.orderId}>{selectedTripDetails?.tid}#</div>
                </div>
            </div>
            <div className={styles.locations}>
                <div className={styles.locationItem}>
                    {placeName}
                    <span className={styles.locationIcon}>
                        <FmdGoodOutlinedIcon />
                    </span>
                </div>
            </div>
        </div>
    );
}

export default LifeTrackingWindowInfo;
